var _rect, _path, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.33331,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CBEEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 20H36.3333C37.4333 20 38.3333 20.9 38.3333 22V34C38.3333 35.1 37.4333 36 36.3333 36H20.3333C19.2333 36 18.3333 35.1 18.3333 34V22C18.3333 20.9 19.2333 20 20.3333 20Z",
    fill: "#16B1B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3333 22L28.3333 29L18.3333 22",
    fill: "#16B1B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3333 22C38.3333 20.9 37.4333 20 36.3333 20H20.3333C19.2333 20 18.3333 20.9 18.3333 22M38.3333 22V34C38.3333 35.1 37.4333 36 36.3333 36H20.3333C19.2333 36 18.3333 35.1 18.3333 34V22M38.3333 22L28.3333 29L18.3333 22",
    stroke: "#0DD1D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.33331,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E6F0F0",
    strokeWidth: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF2);
export default __webpack_public_path__ + "static/media/f2.41633de56f81c0ab73be939b4c331c30.svg";
export { ForwardRef as ReactComponent };